module.exports = __webpack_public_path__ + "img/tile_hosting-the-world.86599184.jpg";